import { createRouter, createWebHistory } from 'vue-router';

import Home from '../views/home/Home.vue';
import Index from '../views/Index.vue';
import Job from '../views/Job.vue'; // 岗位列表
import Resume from '../views/resume/Index.vue'; // 岗位列表
import Deliver from '../views/Deliver.vue'; // 岗位列表
import AdmissionTicket from '../views/AdmissionTicket.vue'; //准考证
import Score from '../views/Score.vue'; //笔试成绩
import Progress from '../views/Progress.vue'; //招聘进度

export const needLoginPage = ['/deliver', '/resume', '/preview', '/admissionTicket', '/score', '/progress'];

const routes = [
  {
    path: '/',
    component: Home,
    redirect: '/index',
    meta: {
      keepAlive: true,
    },
    children: [
      {
        path: '/index', //招聘批次
        component: Index,
        meta: {
          keepAlive: true,
        },
      },
      {
        path: '/job', //岗位列表
        component: Job,
      },
      {
        path: '/deliver', //我的投递
        component: Deliver,
      },
      {
        path: '/resume', //我的简历
        component: Resume,
      },
      {
        path: '/preview', //简历预览
        component: Resume,
      },
      {
        path: '/admissionTicket', //准考证
        component: AdmissionTicket,
      },
      {
        path: '/score', //笔试成绩查询
        component: Score,
      },
      {
        path: '/progress', //笔试成绩查询
        component: Progress,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
